// extracted by mini-css-extract-plugin
export default {"bg":"Modal_bg__N3eW6","content":"Modal_content__A23mp","modal":"Modal_modal__+6Etr","modal__content":"Modal_modal__content__C9t+x","modal__close":"Modal_modal__close__RT7r-"};